import React from "react";

export default function EntitlementsModal({
  user,
  entitlements,
  states,
  onGrant,
  onRevoke,
  onClose
}) {
  // Filter to only those not already granted
  const grantedIds = new Set(entitlements.map(e => e.state_id));
  const grantable = states.filter(s => !grantedIds.has(s.state_id) && s.state_id !== 1);

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: 420, maxHeight: 550, overflowY: "auto", padding: 22 }}>
        <h3>State Entitlements for {user.email}</h3>
        <div style={{ fontWeight: 600, margin: "8px 0 4px" }}>Current Entitlements</div>
        <ul className="entitlement-list" style={{ padding: 0, margin: 0, listStyle: "none", maxHeight: 150, overflowY: "auto" }}>
          {entitlements.filter(e => e.state_id !== 1).length === 0 && (
            <li style={{ color: "#888", fontSize: 14 }}>No states granted.</li>
          )}
          {entitlements.filter(e => e.state_id !== 1).map(ent => (
            <li key={ent.entitlement_id} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
              <span style={{ flex: 1, fontSize: 15 }}>{ent.state_name}</span>
              <button
                onClick={() => onRevoke(ent.entitlement_id)}
                style={{
                  background: "#d32f2f",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  fontSize: 13,
                  padding: "4px 10px",
                  marginLeft: 8,
                  cursor: "pointer"
                }}
              >
                Revoke
              </button>
            </li>
          ))}
        </ul>
        <div style={{ fontWeight: 600, margin: "12px 0 4px" }}>Grant New State</div>
        <ul className="entitlement-list" style={{ padding: 0, margin: 0, listStyle: "none", maxHeight: 150, overflowY: "auto" }}>
          {grantable.length === 0 && (
            <li style={{ color: "#888", fontSize: 14 }}>All states granted.</li>
          )}
          {grantable.map(state => (
            <li key={state.state_id} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
              <span style={{ flex: 1, fontSize: 15 }}>{state.state_name}</span>
              <button
                onClick={() => onGrant(state.state_id)}
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  fontSize: 13,
                  padding: "4px 10px",
                  marginLeft: 8,
                  cursor: "pointer"
                }}
              >
                Grant
              </button>
            </li>
          ))}
        </ul>
        <div className="modal-actions" style={{ marginTop: 18 }}>
          <button className="btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
